import React from "react";
//#region types
import { StatusIndicatorSmallProps } from "models/propTypes/commonPropTypes";
//#endregion
import { CSSHelper } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const StatusIndicatorSmall: React.FC<StatusIndicatorSmallProps> = (props) => {
  return <div className={clsx(cssExports.urgencySQ, CSSHelper.getClassByDisplayType(props.displayType))}></div>;
};

export default StatusIndicatorSmall;
